export default () =>
  `@media all and (-ms-high-contrast: none), (-ms-high-contrast: active)`;